export default __webpack_public_path__ + "static/media/iosnake.7351cbf2.jpeg";